import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=98f894c0&scoped=true"
import script from "./Detailed.vue?vue&type=script&lang=js"
export * from "./Detailed.vue?vue&type=script&lang=js"
import style0 from "./Detailed.vue?vue&type=style&index=0&id=98f894c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f894c0",
  null
  
)

export default component.exports